import React from "react";

export type CaAvatarProfilePhotoChatProps = {
  imageProfile: string;
};

function CaAvatarProfilePhotoChat({ imageProfile }: CaAvatarProfilePhotoChatProps) {
  return (
    <svg
      width='428'
      height='456'
      viewBox='0 0 428 456'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <path
        d='M179.152 313.507C210.992 330.456 248.261 334.063 282.761 323.534C317.26 313.005 346.164 289.202 363.114 257.361C380.064 225.521 383.67 188.252 373.141 153.752C362.612 119.253 338.809 90.3487 306.969 73.3991L243.06 193.453L179.152 313.507Z'
        fill='#8B33FF'
      />
      <path
        d='M144.369 392.35C112.492 375.469 88.6268 346.617 78.023 312.14C67.4193 277.663 70.9457 240.386 87.8265 208.509C104.707 176.632 133.56 152.767 168.036 142.163C202.513 131.56 239.79 135.086 271.667 151.967L208.018 272.158L144.369 392.35Z'
        fill='#FE901E'
      />
      <mask
        id='mask0_1400_13571'
        style={{ maskType: "alpha" }}
        maskUnits='userSpaceOnUse'
        x='77'
        y='90'
        width='275'
        height='275'
      >
        <circle cx='214.165' cy='227.261' r='136.898' fill='url(#pattern0)' />
        <circle cx='214.165' cy='227.261' r='136.898' fill='black' fillOpacity='0.4' />
      </mask>
      <g mask='url(#mask0_1400_13571)'>
        <rect x='70.8765' y='83.4198' width='286.57' height='287.67' fill='url(#pattern1)' />
      </g>
      <circle
        opacity='0.2'
        cx='213.647'
        cy='222.897'
        r='139.743'
        transform='rotate(-40.5603 213.647 222.897)'
        stroke='#E9F4FE'
      />
      <circle
        opacity='0.2'
        cx='212.158'
        cy='212.404'
        r='149.97'
        transform='rotate(-40.5603 212.158 212.404)'
        stroke='#E9F4FE'
      />
      <path
        d='M382.942 144.131L382.588 144.484L382.942 144.838L388.289 150.185L388.643 150.538L388.996 150.185L395.811 143.37L402.626 150.185L402.979 150.538L403.333 150.185L408.68 144.838L409.034 144.484L408.68 144.131L401.865 137.316L408.719 130.462L409.072 130.109L408.719 129.755L403.372 124.408L403.018 124.054L402.665 124.408L395.811 131.262L388.958 124.408L388.604 124.054L388.25 124.408L382.903 129.755L382.55 130.109L382.903 130.462L389.757 137.316L382.942 144.131Z'
        stroke='#CBCFDD'
      />
      <circle
        cx='200.972'
        cy='381.701'
        r='6.97295'
        transform='rotate(42.267 200.972 381.701)'
        fill='#FE901E'
      />
      <circle
        cx='169.712'
        cy='380.12'
        r='9.96136'
        transform='rotate(42.267 169.712 380.12)'
        fill='#8B33FF'
      />
      <defs>
        <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use
            xlinkHref='#image0_1400_13571'
            transform='translate(0 -0.0275651) scale(0.00153139)'
          />
        </pattern>
        <pattern id='pattern1' patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use
            xlinkHref='#image1_1400_13571'
            transform='matrix(0.0012548 0 0 0.00125 -0.00191814 0)'
          />
        </pattern>
        <image
          id='image0_1400_13571'
          width='800'
          height='800'
          xlinkHref={imageProfile}
          preserveAspectRatio='xMidYMid slice'
        />
        <image
          id='image1_1400_13571'
          width='800'
          height='800'
          xlinkHref={imageProfile}
          preserveAspectRatio='xMidYMid slice'
        />
      </defs>
    </svg>
  );
}

export default CaAvatarProfilePhotoChat;
